import { render, staticRenderFns } from "./decorationAudit.vue?vue&type=template&id=cdeb17ca&scoped=true&"
import script from "./decorationAudit.vue?vue&type=script&lang=js&"
export * from "./decorationAudit.vue?vue&type=script&lang=js&"
import style0 from "./decorationAudit.vue?vue&type=style&index=0&id=cdeb17ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdeb17ca",
  null
  
)

export default component.exports